export function isRealtimeMinutesEntitlement(entitlements) {
  return entitlements?.entitlementCode === "REALTIME_MINUTES";
}

export function isRealtimeLimitedEntitlement(entitlements) {
  return isRealtimeMinutesEntitlement(entitlements) && !entitlements?.isUnlimited;
}

export function isBetaRealtimeEntitlement(entitlements) {
  return isRealtimeMinutesEntitlement(entitlements) && entitlements?.planCode === "BETA";
}

export function formatRemainingSecondsLabel(remainingSeconds, options = {}) {
  const { suffix = "left", unlimited = false } = options;
  if (unlimited) return "Unlimited";

  const totalSeconds = Math.max(0, Math.round(Number(remainingSeconds || 0)));
  const mins = Math.floor(totalSeconds / 60);
  const secs = String(totalSeconds % 60).padStart(2, "0");
  return `${mins}:${secs} ${suffix}`;
}

export function formatRemainingMinutesLabel(remainingMinutes, options = {}) {
  return formatRemainingSecondsLabel(Number(remainingMinutes || 0) * 60, options);
}
